export const showBar = ref(false)
export const showManager = ref(false)
export const gtagReady = ref(false)

export interface ManageCookiesSetting {
  showBar?: boolean
  optional: Record<string, boolean>
}

// stored cookie decision; a missing, corrupted or unreadable entry (blocked storage throws on access) -> {} (bar shown again)
export function readManageCookies(): Partial<ManageCookiesSetting> {
  try {
    const raw = localStorage?.getItem?.('manageCookies')
    const settings: unknown = raw ? JSON.parse(raw) : null
    return settings && typeof settings === 'object' ? settings as Partial<ManageCookiesSetting> : {}
  } catch {
    return {}
  }
}
